import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalLogs: 0,
    totalProjects: 0,
    totalCubicYards: 0,
    totalManhours: 0
  });
  const [recentLogs, setRecentLogs] = useState([]);
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingProject, setEditingProject] = useState(null);
  const [loading, setLoading] = useState(true);

  // Define functions before useEffect hooks
  const fetchDashboardData = async () => {
    try {
      const [logsResponse, projectsResponse] = await Promise.all([
        api.get('/logs'),
        api.get('/projects')
      ]);

      const logs = logsResponse.data;
      const projects = projectsResponse.data;

      const totalCY = logs.reduce((sum, log) => sum + log.cubic_yards, 0);
      const totalMH = logs.reduce((sum, log) => sum + log.total_manhours, 0);

      setStats({
        totalLogs: logs.length,
        totalProjects: projects.filter(p => p.status === 'active').length,
        totalCubicYards: totalCY.toFixed(2),
        totalManhours: totalMH.toFixed(2)
      });

      setRecentLogs(logs.slice(0, 5));
      setLoading(false);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      setLoading(false);
    }
  };

  const fetchProjects = async () => {
    try {
      const response = await api.get('/projects');
      setProjects(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching projects:', error);
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this project?')) {
      try {
        await api.delete(`/projects/${id}`);
        fetchProjects();
      } catch (error) {
        console.error('Error delching project:', error);
        alert('Failed to delete project');
      }
    }
  };

  const handleEdit = (project) => {
    setEditingProject(project);
    setShowForm(true);
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingProject(null);
    fetchProjects();
  };

  // useEffect hooks after function definitions
  useEffect(() => {
    fetchDashboardData();
  }, []);

  useEffect(() => {
    fetchProjects();
  }, []);

  if (loading) return <div className="loading">Loading dashboard...</div>;

  return (
    <div className="dashboard">
      <div className="dashboard-grid">
        <div className="stat-card">
          <h4>Total Production Logs</h4>
          <div className="value">{stats.totalLogs}</div>
        </div>
        <div className="stat-card">
          <h4>Active Projects</h4>
          <div className="value">{stats.totalProjects}</div>
        </div>
        <div className="stat-card">
          <h4>Total Cubic Yards</h4>
          <div className="value">{stats.totalCubicYards}</div>
        </div>
        <div className="stat-card">
          <h4>Total Manhours</h4>
          <div className="value">{stats.totalManhours}</div>
        </div>
      </div>

      <div className="card">
        <h3>Recent Production Logs</h3>
        {recentLogs.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Project</th>
                <th>Element</th>
                <th>Cubic Yards</th>
                <th>MH/CY</th>
              </tr>
            </thead>
            <tbody>
              {recentLogs.map(log => (
                <tr key={log.id}>
                  <td>{new Date(log.log_date).toLocaleDateString()}</td>
                  <td>{log.project_name}</td>
                  <td>{log.element_detail}</td>
                  <td>{log.cubic_yards}</td>
                  <td>{log.mh_per_cy}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No production logs yet. Create your first log to get started!</p>
        )}
      </div>
      <div className="card">
        <h3>All Projects</h3>
        {projects.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Floors</th>
                <th>Status</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {projects.map(project => (
                <tr key={project.id}>
                  <td>
                    <a 
                      href="#" 
                      onClick={(e) => { e.preventDefault(); navigate(`/projects/${project.id}`); }}
                      style={{ color: '#667eea', textDecoration: 'none', fontWeight: 'bold' }}
                    >
                      {project.name}
                    </a>
                  </td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      borderRadius: '4px',
                      background: '#e3f2fd',
                      color: '#1565c0'
                    }}>
                      {project.floors?.length || 0}
                    </span>
                  </td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      borderRadius: '4px',
                      background: project.status === 'active' ? '#d4edda' : '#f8d7da',
                      color: project.status === 'active' ? '#155724' : '#721c24'
                    }}>
                      {project.status}
                    </span>
                  </td>
                  <td>{new Date(project.created_at).toLocaleDateString()}</td>
                  <td>
                    {/* <button 
                      onClick={() => handleEdit(project)} 
                      className="secondary"
                      style={{ marginRight: '10px' }}
                    >
                      Edit
                    </button> */}
                    <button 
                      onClick={() => handleDelete(project.id)} 
                      className="danger"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No projects yet. Create your first project!</p>
        )}
      </div>
    </div>
  );
};

export default Dashboard;